module.exports = __webpack_public_path__ + "static/img/jiasimin.4056ead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/jiasimin.jpg
// module id = +sVK
// module chunks = 0